// src/tiles/CategoryPill.jsx
import React from 'react';
import { Chip } from '@mui/material';

// Icons
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';          // job
import BoltIcon from '@mui/icons-material/Bolt';                         // trigger
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';               // solution-prev
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';           // solution-considered
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';       // impression
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined'; // insight
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';       // situation
import TimelineIcon from '@mui/icons-material/Timeline';                 // workflow
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';         // product
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined'; // measure
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined'; // nextjob

const MAP = {
  job: { label: 'Job', Icon: WorkOutlineIcon },
  trigger: { label: 'Trigger', Icon: BoltIcon },
  'solution-prev': { label: 'Prev Solution', Icon: SwapHorizIcon },
  'solution-considered': { label: 'Considered', Icon: HelpOutlineIcon },
  impression: { label: 'Impression', Icon: EmojiEmotionsIcon },
  insight: { label: 'Insight', Icon: LightbulbOutlinedIcon },
  situation: { label: 'Situation', Icon: PlaceOutlinedIcon },
  workflow: { label: 'Workflow', Icon: TimelineIcon },
  product: { label: 'Product', Icon: AppsOutlinedIcon },
  measure: { label: 'Measure', Icon: BarChartOutlinedIcon },
  nextjob: { label: 'Next Job', Icon: TrendingUpOutlinedIcon },
};

export default function CategoryPill({ category }) {
  if (!category) return null;
  const meta = MAP[category] || { label: category, Icon: AppsOutlinedIcon };
  const { label, Icon } = meta;
  return (
    <Chip
      size="small"
      variant="outlined"
      icon={<Icon fontSize="small" />}
      label={label}
      sx={{ fontWeight: 500 }}
    />
  );
}
